import { Icon } from "../components/Icon";
import { FeatureCard } from "../components/FeatureCard";
import { SectionHeading } from "../components/SectionHeading";
import maryam from "../../../pictures/home/maryam.jpg";
import zain from "../../../pictures/home/zain.jpg";
import { RichText, useSiteTranslation } from "../i18n";
import "../styles/features.css";

function PrivacyVisual() {
  return (
    <div className="privacy-visual">
      <div className="privacy-person" style={{ backgroundImage: `url(${maryam})` }} />
      <span>
        <Icon name="lock" />
      </span>
      <div className="privacy-person" style={{ backgroundImage: `url(${zain})` }} />
    </div>
  );
}

function WaliLine() {
  const { t } = useSiteTranslation();
  return (
    <div className="wali-line">
      <span>{t("home.features.wali.match")}</span>
      <i />
      <span>{t("home.features.wali.wali")}</span>
    </div>
  );
}

/** label, title and text props for a feature card from home.features.<key>. */
function cardCopy(t, key) {
  return {
    label: t(`home.features.${key}.label`),
    title: t(`home.features.${key}.title`),
    text: t(`home.features.${key}.text`),
  };
}

export function FeaturesSection() {
  const { t } = useSiteTranslation();
  return (
    <section className="section features" id="safety">
      <div className="wrap">
        <SectionHeading
          eyebrow={t("home.features.eyebrow")}
          title={<RichText k="home.features.title" />}
          lead={t("home.features.lead")}
        />
        <div className="bento-grid">
          <FeatureCard
            variant="large dark"
            icon="eye"
            {...cardCopy(t, "privacy")}
          >
            <PrivacyVisual />
          </FeatureCard>
          <FeatureCard
            variant="gold"
            delay=".08s"
            icon="video"
            {...cardCopy(t, "communication")}
          />
          <FeatureCard
            variant="light"
            icon="filter"
            {...cardCopy(t, "filters")}
          />
          <FeatureCard
            variant="light"
            delay=".08s"
            icon="shield"
            {...cardCopy(t, "verification")}
          />
          <FeatureCard
            variant="wide warm"
            icon="family"
            {...cardCopy(t, "wali")}
            aside={<WaliLine />}
          />
          <article className="feature-card wide quote-card" data-reveal style={{ "--delay": ".08s" }}>
            <Icon name="moon" className="quote-moon" />
            <blockquote>{t("home.features.quote")}</blockquote>
            <cite>{t("home.features.quoteSource")}</cite>
          </article>
        </div>
      </div>
    </section>
  );
}
